<template>
  <v-app id="password-app">
    <!-- Hero Header -->
    <div class="password-hero">
      <div class="password-hero__content">
        <div class="password-hero__icon">
          <v-icon color="white" size="48">mdi-shield-lock</v-icon>
        </div>
        <h1 class="password-hero__title">Sécurité du compte</h1>
        <p class="password-hero__subtitle">
          Modifiez votre mot de passe pour renforcer la sécurité de votre compte
        </p>
      </div>
    </div>

    <div class="password-container">
      <v-form @submit.prevent="submitForm">
        <v-card class="password-card" elevation="0">
          <!-- Alert d'information -->
          <v-alert
            border="left"
            colored-border
            color="#159e72"
            elevation="0"
            class="password-alert"
          >
            <div class="d-flex align-center">
              <v-icon color="#159e72" class="mr-3">mdi-information</v-icon>
              <div>
                <div class="password-alert__title">Conseils de sécurité</div>
                <div class="password-alert__text">
                  Utilisez un mot de passe fort avec au moins 8 caractères, incluant des majuscules, minuscules et chiffres.
                </div>
              </div>
            </div>
          </v-alert>

          <v-card-text class="pa-6">
            <!-- Email (disabled) -->
            <div class="password-field-group">
              <label class="password-label">
                <v-icon color="#159e72" size="20" class="mr-2">mdi-email</v-icon>
                Adresse e-mail
              </label>
              <v-text-field
                v-model="userParams.email"
                outlined
                dense
                disabled
                prepend-inner-icon="mdi-account"
                class="password-field password-field--disabled"
              ></v-text-field>
            </div>

            <!-- Ancien mot de passe -->
            <div class="password-field-group mt-6">
              <label class="password-label">
                <v-icon color="#159e72" size="20" class="mr-2">mdi-lock-outline</v-icon>
                Mot de passe actuel <span class="red--text">*</span>
              </label>
              <v-text-field
                v-model.trim="$v.userParams.oldPassWord.$model"
                :error-messages="oldPasswordError"
                :append-icon="oldPasswordIsVisible ? 'mdi-eye' : 'mdi-eye-off'"
                :type="oldPasswordIsVisible ? 'text' : 'password'"
                @click:append="oldPasswordIsVisible = !oldPasswordIsVisible"
                outlined
                dense
                prepend-inner-icon="mdi-lock-check"
                placeholder="Entrez votre mot de passe actuel"
                class="password-field"
              ></v-text-field>
            </div>

            <!-- Nouveau mot de passe -->
            <div class="password-field-group mt-6">
              <label class="password-label">
                <v-icon color="#159e72" size="20" class="mr-2">mdi-lock-plus</v-icon>
                Nouveau mot de passe <span class="red--text">*</span>
              </label>
              <v-text-field
                v-model.trim="$v.userParams.newPassWord.$model"
                :error-messages="newPasswordError"
                :append-icon="newPasswordIsVisible ? 'mdi-eye' : 'mdi-eye-off'"
                :type="newPasswordIsVisible ? 'text' : 'password'"
                @click:append="newPasswordIsVisible = !newPasswordIsVisible"
                outlined
                dense
                prepend-inner-icon="mdi-lock-reset"
                placeholder="Entrez votre nouveau mot de passe"
                class="password-field"
              >
                <template v-slot:append-outer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="#64748b"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span>Minimum 8 caractères recommandés</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-6">
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              outlined
              color="#64748b"
              class="password-btn password-btn--cancel"
              @click="resetForm"
            >
              <v-icon left size="18">mdi-refresh</v-icon>
              Réinitialiser
            </v-btn>
            <v-btn
              type="submit"
              color="#159e72"
              class="password-btn password-btn--submit"
              elevation="2"
            >
              <v-icon left size="18" color="white">mdi-check-circle</v-icon>
              <span style="color: white">Modifier le mot de passe</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>

    <v-overlay :value="overlay">
      <div class="password-overlay">
        <v-progress-circular indeterminate size="64" color="#159e72"></v-progress-circular>
        <p class="password-overlay__text mt-4">Modification en cours...</p>
      </div>
    </v-overlay>
  </v-app>
</template>

<script>
import { API_RESET_PASSWORD_USER , HEADERS } from '../globalConfig/globalConstConfig';
import axios from 'axios';
import { required } from 'vuelidate/lib/validators'
export default {
    name:"changerPassword",
    data(){
        return{
            errorMsg : null,
            successMsg : null,
            overlay: null, 

            oldPasswordIsVisible : false,
            newPasswordIsVisible : false , 

            userParams:{
                email: null,
                oldPassWord: null,
                newPassWord:null
            },

            userReset:{
                data:{
                    email:null,
                    oldPassWord : null,
                    newPassWord : null, 
                }
            }
        }
    },

    validations:{
        userParams:{
            oldPassWord:{
                required
            },
            newPassWord:{
                required
            }
        }
    },

    methods:{

        async retrieveUserInfo(){
            /**
             * RECUPERER LES DONNEES UTILISATEURS
             */
            if (this.$store.state.userAuthentified !== null) {
                this.userParams.email = this.$store.state.userAuthentified.email;
            }
        },

        // RÉINITIALISER LE FORMULAIRE
        resetForm() {
            this.userParams.oldPassWord = null;
            this.userParams.newPassWord = null;
            this.$v.$reset();
        },

        // SOUMISSION DU FORMULAIRE
        submitForm(){
            this.$v.$touch();
            if(this.$v.userParams.$invalid) {
                this.$swal.fire(
                    "Champs manquants",
                    "Veuillez remplir tous les champs obligatoires",
                    "warning"
                );
            } else {
                this.resetPasswordUser();
            }
        },


        //CHANGER DE MOT DE PASSE
        async resetPasswordUser(){
            this.overlay = true ;
            this.userReset.data.email = this.userParams.email;
            this.userReset.data.oldPassWord = this.userParams.oldPassWord;
            this.userReset.data.newPassWord = this.userParams.newPassWord;
            await axios.post(API_RESET_PASSWORD_USER, this.userReset , { headers : HEADERS(this.$store.state.userAuthentified.token) } ).then((response) => {
                if (response.status == 200) {
                    if (response.data.status.code == 800) {
                        this.successMsg = response.data.status.message
                        this.$swal.fire('Mot de Passe modifié' , this.successMsg , 'success')
                        this.userReset.data.email = null;
                        this.userReset.data.oldPassword = null;
                        this.userReset.data.newPassword = null;
                    }else{
                        this.errorMsg = response.data.status.message
                        this.$swal.fire('Erreur' , this.errorMsg , 'error')
                        this.userReset.data.email = null;
                        this.userReset.data.oldPassWord = null;
                        this.userReset.data.newPassWord = null;
                    }  
                    
                }
                else if (response.status == 204) {
                    this.warningMsg = "Erreur , lors de la création";
                    this.$swal.fire('Erreur' , this.warningMsg , 'warning')
                    this.userReset.data.email = null;
                    this.userReset.data.oldPassWord = null;
                    this.userReset.data.newPassWord = null;
                }
                else{
                    this.errorMsg = "Erreur , opération de création impossible";
                    this.$swal.fire('Erreur' , this.errorMsg , 'error')
                    this.userReset.data.email = null;
                    this.userReset.data.oldPassWord = null;
                    this.userReset.data.newPassWord = null;
                }
            }).catch((e) => {
                this.$swal.fire('Erreur' , e , 'error')
                this.userReset.data.email = null;
                this.userReset.data.oldPassWord = null;
                this.userReset.data.newPassWord = null;
            }).finally(() => {
                this.overlay = false;
            })
        }

    },

    computed:{

        //GESTION DES CHAMPS UTILISATEURS

        oldPasswordError(){
            const errors = [];
            if (!this.$v.userParams.oldPassWord.$dirty) return errors
            !this.$v.userParams.oldPassWord.required && errors.push('Entrer l\'ancien mot de passe.')
            return errors 
        },

        newPasswordError(){
            const errors = [];
            if (!this.$v.userParams.newPassWord.$dirty) return errors
            !this.$v.userParams.newPassWord.required && errors.push('Le nouveau mot de passe est obligatoire.')
            return errors 
        },

    },

    mounted(){
        this.retrieveUserInfo();
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;900&display=swap');

* {
  font-family: "Montserrat", sans-serif;
}

#password-app {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  min-height: 100vh;
}

/* Hero Section */
.password-hero {
  background: linear-gradient(135deg, #159e72 0%, #0c2461 100%);
  padding: 60px 0;
  position: relative;
  overflow: hidden;
}

.password-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.4;
}

.password-hero__content {
  text-align: center;
  position: relative;
  z-index: 1;
}

.password-hero__icon {
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.password-hero__title {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: clamp(32px, 5vw, 48px);
  color: white;
  margin-bottom: 12px;
  letter-spacing: -1px;
}

.password-hero__subtitle {
  font-family: "Montserrat";
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  max-width: 600px;
  margin: 0 auto;
}

/* Container */
.password-container {
  max-width: 700px;
  margin: -40px auto 40px;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

/* Card */
.password-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
}

.password-card:hover {
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);
}

/* Alert */
.password-alert {
  margin: 24px;
  background: rgba(21, 158, 114, 0.04) !important;
  border-radius: 12px;
}

.password-alert__title {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: 15px;
  color: #0f172a;
  margin-bottom: 4px;
}

.password-alert__text {
  font-family: "Montserrat";
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
  line-height: 1.5;
}

/* Field Group */
.password-field-group {
  margin-bottom: 8px;
}

.password-label {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: 14px;
  color: #0f172a;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

/* Fields */
.password-field {
  font-family: "Montserrat";
}

.password-field >>> .v-label {
  font-family: "Montserrat" !important;
  font-weight: 600 !important;
}

.password-field >>> input {
  font-family: "Montserrat" !important;
  font-weight: 600 !important;
  color: #0f172a !important;
}

.password-field >>> .v-input__prepend-inner {
  margin-top: 8px !important;
}

.password-field >>> .v-input__append-inner {
  margin-top: 8px !important;
}

.password-field--disabled >>> input {
  color: #94a3b8 !important;
}

.password-field >>> .v-text-field__details {
  padding-left: 0;
}

.password-field >>> .v-messages__message {
  font-family: "Montserrat" !important;
  font-weight: 600 !important;
  font-size: 12px !important;
}

/* Buttons */
.password-btn {
  font-family: "Montserrat";
  font-weight: 900;
  text-transform: none;
  border-radius: 12px;
  padding: 12px 24px !important;
  transition: all 0.3s ease;
}

.password-btn:hover {
  transform: translateY(-2px);
}

.password-btn--cancel:hover {
  background: rgba(100, 116, 139, 0.08) !important;
}

.password-btn--submit:hover {
  box-shadow: 0 8px 24px rgba(21, 158, 114, 0.3) !important;
}

/* Overlay */
.password-overlay {
  text-align: center;
}

.password-overlay__text {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: 16px;
  color: white;
  margin: 0;
}

/* Responsive */
@media (max-width: 600px) {
  .password-hero {
    padding: 40px 0;
  }

  .password-container {
    margin-top: -30px;
  }

  .password-alert {
    margin: 16px;
  }

  .password-card >>> .v-card-text {
    padding: 16px !important;
  }

  .password-card >>> .v-card-actions {
    padding: 16px !important;
    flex-direction: column;
    gap: 12px;
  }

  .password-btn {
    width: 100%;
  }
}
</style>